import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import { PATH_TO_MODULE } from "../constants/modules";

const ProtectedRoute = ({ allowedRoles }) => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();
  const currentPath = location.pathname;

  // if (!isAuthenticated) return <Navigate to="/login" />;

  // if (allowedRoles && !allowedRoles.includes(user?.role)) {
  //   return <Navigate to="/unauthorized" />;
  // }

  // const currentPath = location.pathname.split("/")[1];
  // const currentModule = PATH_TO_MODULE[currentPath];  

  // if (currentModule) {
  //   const hasAccess = user?.permissions?.some(
  //     (perm) => perm.module === currentModule && perm.CanView
  //   );
  //   if (!hasAccess) return <Navigate to="/unauthorized" />;
  // }

  const role = user?.roleName?.toLowerCase() || localStorage.getItem("lastRole");
  const roleLoginRoutes = {
    admin: "/admin-login",
    parent: "/parent-login",
    student: "/student-login",
    employee: "/employee-login",
    teacher: "/employee-login",
  };

  const loginRedirectPath = roleLoginRoutes[role] || "/admin-login";
  const getFlattenedRoutes = (routes = []) => {
    const flattened = [];

    routes.forEach((route) => {
      flattened.push({
        path: route.routePath,
        canView: route.canView,
      });

      if (route.children && Array.isArray(route.children)) {
        route.children.forEach((sub) => {
          flattened.push({
            path: `${sub.routePath}`,
            canView: sub.canView,
          });
        });
      }
    });

    return flattened;
  };


  // if (!isAuthenticated) return <Navigate to="/admin-login" state={{ from: location }} replace />;  

  // if (allowedRoles && !allowedRoles.includes(user?.roleName?.toLowerCase())) {
  //   return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  // }

  const accessibleRoutes = getFlattenedRoutes(user?.routes || []);
  const matchedRoute = accessibleRoutes.find((r) => r.path === currentPath);


  // if (!matchedRoute || !matchedRoute.canView) {
  //   return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  // } 


  if (!isAuthenticated || allowedRoles && !allowedRoles.includes(user?.roleName?.toLowerCase()) || !matchedRoute || !matchedRoute.canView) {
    return <Navigate to={loginRedirectPath} state={{ from: location }} replace />;
  }
  return <Outlet />;
};

export default ProtectedRoute;
